import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AdminService } from '../../services/admin.service';
import { AuthService } from '../../auth.service';
import * as vo from 'src/app/interface/_index';
import { DatePipe } from '@angular/common';

@Component({ standalone: false,
  selector: 'app-account-merchants',
  templateUrl: './account-merchants.component.html',
  styleUrls: ['./account-merchants.component.scss']
})
export class AccountMerchantsComponent implements OnInit {
  // set via BsModalService initialState
  username!: string;

  merchants: vo.SubMerchant[] = [];
  isLoading: boolean = false;
  expandedCell: string | null = null;
  userDetails: any;

  constructor(
    public modalRef: BsModalRef,
    private adminService: AdminService,
    private authService: AuthService,
    private datePipe: DatePipe
  ) {}

  ngOnInit(): void {
    this.userDetails = this.authService.getSession();
    this.getSubMerchants();
  }

  getSubMerchants(): void {
    this.isLoading = true;
    this.adminService.getSubMerchants(this.userDetails.token, this.username).subscribe({
      next: (response: any) => {
        this.merchants = response.result?.data ?? response.result ?? [];
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Failed to load sub-merchants:', error);
        this.isLoading = false;
      }
    });
  }

  formatTimestamp(timestamp: string): string {
      if (!timestamp) return '—';
      const iso = timestamp.split('.')[0].replace(' ', 'T') + 'Z';
      const d = new Date(iso);
      if (isNaN(d.getTime())) return timestamp;
      return this.datePipe.transform(d, 'MMMM d, yyyy h:mm a', '+0800') ?? '';
  }
}